import React from "react"
import styled from "styled-components"
import FeatureIcon from "./FeatureIcon"
import { SECONDARY_TEXT, PRIMARY_TEXT, ACTIVE_TEXT } from "./consts/colors"

const ArticleCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  margin-top: 50px;
  max-width: 1200px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin-top: 150px;
    margin-bottom: 50px;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 50px;
  }
`

const ArticleCardWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  flex-direction: row;

  width: 100%;
  max-width: 500px;
  margin-right: 20px;
  margin-left: 0px;
  background-color: white;
  box-shadow: 0px 5px 10px ${SECONDARY_TEXT};
  border-radius: 12px;
  transition: 300ms ease all;
  color: ${PRIMARY_TEXT};
  &:nth-child(2) {
    margin-right: 0px;
    margin-left: 20px;

    @media (max-width: 768px) {
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom: 0px;
      padding: 5px;
    }

    @media (max-width: 480px) {
      width: 100%;
      padding: 5px;
    }
  }

  :hover {
    transform: translateY(-3px);
    box-shadow: 0px 8px 20px ${SECONDARY_TEXT};
  }

  a {
    color: ${ACTIVE_TEXT};
    display: block;
    height: 90%;
    width: 90%;
  }

  @media (max-width: 768px) {
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 30px;
    padding: 5px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
    width: 100%;
    padding: 5px;
  }
`

const ArticleCardItemContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 15px 0px;
  padding-right: 5px;
  margin-left: 30px;
  width: 100%;

  @media (max-width: 768px) {
    margin-left: 35px;
    padding: 10px 0px;
  }

  @media (max-width: 615px) {
    padding: 5px 0px;
  }
`

const ArticleCardItemIcon = styled.div`
  transform: scale(1.7);
  width: 30%;
  max-width: 100px;
  position: relative;
  right: 15px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    transform: scale(1.4);
    top: 2px;
    width: 20%;
  }

  @media (max-width: 480px) {
    transform: scale(0.8);
    right: 30px;
    width: 10%;
  }
`

const ArticleCardItemName = styled.h4`
  font-size: 16px;

  @media (max-width: 615px) {
    font-size: 14px;
  }
`

const ArticleCardItemDescription = styled.p`
  font-size: 15px;
  line-height: 21px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 19px;
  }

  @media (max-width: 615px) {
    font-size: 13px;
    line-height: 17px;
  }
`

const ArticleCardItemLink = styled.a`
  font-size: 15px;
  margin-right: 20px;
  margin-left: 0px;
  &:nth-child(2) {
    margin-right: 0px;
    margin-left: 20px;

    @media (max-width: 768px) {
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom: 0px;
      padding: 5px;
    }

    @media (max-width: 480px) {
      width: 100%;
      padding: 5px;
    }
  }

  @media (max-width: 768px) {
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 30px;
    padding: 5px;
  }

  @media (max-width: 615px) {
    font-size: 13px;
    margin-bottom: 20px;
    width: 100%;
    padding: 5px;
  }
`

const ArticleCard = ({ articles }) => {
  if (!articles || articles.length < 1) {
    return null
  }
  return (
    <ArticleCardsContainer>
      {articles.slice(0, 4).map((article, index, props) => (
        <ArticleCardItemLink href={article.articleLink}>
          <ArticleCardWrapper key={index}>
            <ArticleCardItemIcon>
              <FeatureIcon name={article.iconName} />
            </ArticleCardItemIcon>
            <ArticleCardItemContent>
              <ArticleCardItemName>{article.articleName}</ArticleCardItemName>
              <ArticleCardItemDescription>
                {article.articleDescription}
              </ArticleCardItemDescription>
              <p
                style={{
                  color: "#5759FF",
                  fontSize: "15px",
                  fontWeight: "700"
                }}>
                {article.articleLinkText}
              </p>
            </ArticleCardItemContent>
          </ArticleCardWrapper>
        </ArticleCardItemLink>
      ))}
    </ArticleCardsContainer>
  )
}

export default ({ articles }) => <ArticleCard articles={articles} />



// WEBPACK FOOTER //
// ./src/components/ArticleCard.js